// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2casg","description":"PatientConsentPreview_description__1wRUX"};